import * as React from "react";
export function SvgPrepFlowAnnotationsFilter(
  props: React.SVGProps<SVGSVGElement>
): JSX.Element {
  return (
    <svg width={13} height={13} {...props}>
      <path
        d="M10.8 2H2.2c-.3 0-.6.3-.6.6 0 .2.1.3.2.5L5 6.8V10c0 .6.4 1 1 1h1c.6 0 1-.4 1-1V6.8l3.1-3.7c.1-.1.2-.3.2-.5.1-.3-.2-.6-.5-.6zM7 6.4V10H6V6.4L3 3h7L7 6.4z"
        fill="#666"
      />
    </svg>
  );
}
